<!--
  创建时间：2023/7/27 16:19
  创建人：toyehuang
  文件描述：head 页面头部布局
-->
<template>
  <header class="layout-head" :class="{ 'no-border': isNoBorder }">
    <div class="layout_header_top def-w f-b-c fc99">
      <div class="top-left f-b-c">
        <span>Hi,欢迎来到牡丹江阳光交易平台！</span>
        <!--        <a href="https://www.cynee.net" class="color-theme-red ml-20" target="_blank">产权交易</a>-->
      </div>
      <div class="top-right">
        服务热线：{{ info.technicalHotline }}({{ info.workTime }})
        <!-- 项目咨询：{{ info.consultHotline }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        工作时间：{{ info.workTime }} -->
      </div>
    </div>
    <div class="layout_head_container bgff">
      <div class="def-w f-b-c">
        <img :src="info.logo" alt="云南省国有企业阳光采购平台" />
        <head-search />
      </div>
    </div>
    <head-nav />
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import HeadSearch from "@/layout/components/LayoutHead/HeadSearch.vue";
import HeadNav from "@/layout/components/LayoutHead/HeadNav/index.vue";

export default {
  name: "LayoutHead",
  components: { HeadNav, HeadSearch },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["site"]),
    isNoBorder() {
      return this.$route.meta.noNavBorder;
    },
  },
  created() {
    this.info = this.site || {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.layout-head {
  position: sticky; /* 关键属性 */
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  background-color: #f5f5f5;
  border-bottom: 2px solid $--color-primary;
  &.no-border {
    border-bottom: none;
  }
  .layout_header_top {
    height: 40px;
    .top-left {
      .button-group {
        white-space: nowrap;
      }
    }
    .top-right {
    }
  }
  .layout_head_container {
    .def-w {
      height: 120px;
    }
  }
}
</style>
